import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enroll-menu',
  templateUrl: './enroll-menu.component.html',
  styleUrls: ['./enroll-menu.component.scss']
})
export class EnrollMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
